import React from 'react';

import {
  Button,
  Typography,
} from '@material-ui/core';


const activityAction = (props) => {
  let display = null;
  let actions = null;
  if (props.type === 'shortlists') {
    actions = (
      <Button onClick={props.deleteActivity} variant="outlined" color="primary">
        Delete this shortlist?
      </Button>
    );
  }
  if (props.type === 'interests' && props.item.activity_type === 'sent' && props.item.is_deletable && !props.item.reply) {
    actions = (
      <Button onClick={props.deleteActivity} variant="outlined" color="primary">
        Undo this interest?
      </Button>
    );
  }
  if (props.type === 'requests' && props.item.activity_type === 'sent' && props.item.is_deletable && !props.item.reply) {
    actions = (
      <Button onClick={props.deleteActivity} variant="outlined" color="primary">
        Undo this request?
      </Button>
    );
  }

  if ((props.type === 'interests' || props.type === 'requests' || props.type === 'recommendations') && props.item.activity_type === 'received') {
    actions = (
      <React.Fragment>
        {!props.item.reply
          ? <Typography style={{ marginBottom: '5px' }}>Respond by clicking any options below.</Typography>
          : <Typography style={{ marginBottom: '5px' }}>Changed your mind?</Typography>}
        {(props.item.reply && (props.item.reply === 'accept' || props.item.reply.reply === 'accept'))
          ? null
          : (
            <Button onClick={() => props.replyActivity('accept')} variant="outlined" color="primary" style={{ marginRight: '10px' }}>
              Accept
            </Button>)}
        {(props.item.reply && (props.item.reply === 'reject' || props.item.reply.reply === 'reject'))
          ? null
          : (
            <Button onClick={() => props.replyActivity('reject')} variant="outlined" color="primary">
              Reject
            </Button>)}
        <br /><br />
      </React.Fragment>
    );
  }

  let reply = null;
  if (props.item.reply && props.item.reply.reply === 'accept') {
    reply = 'ACCEPTED';
  } else {
    reply = 'REJECTED';
  }

  if (props.type === 'interests' && props.item.activity_type === 'received' && props.item.reply) {
    display = (
      <Typography variant="subheading" style={{ marginBottom: '5px' }}>You have <b>{reply}</b> this interest on {props.item.reply.created_at}.</Typography>
    );
  }

  if (props.type === 'requests' && props.item.activity_type === 'received' && props.item.reply) {
    display = (
      <Typography variant="subheading" style={{ marginBottom: '5px' }}>You have <b>{reply}</b> this request on {props.item.reply.created_at}.</Typography>
    );
  }

  if ((props.type === 'requests' || props.type === 'interests') && props.item.activity_type === 'sent' && props.item.reply) {
    display = (
      <Typography variant="subheading" style={{ marginBottom: '5px' }}>You have received reply as <b>{reply}</b> on {props.item.reply.created_at}.</Typography>
    );
  }

  if (props.type === 'recommendations' && props.item.reply !== '') {
    if (props.item.reply === 'accept') { reply = 'ACCEPTED'; } else { reply = 'REJECTED'; }
    display = (
      <Typography variant="subheading" style={{ marginBottom: '5px' }}>You have replied to this recommendation as <b>{reply}</b>.</Typography>
    );
  }

  return (
    <React.Fragment>
      {display}
      {actions}
    </React.Fragment>
  );
};

export default activityAction;



// WEBPACK FOOTER //
// ./src/activities/components/ActivityAction.js